'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidCamera = function IoAndroidCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.6 21.9c0-3.3 1.6-4.9 4.9-4.9s4.9 1.6 4.9 4.9-1.6 4.9-4.9 4.9-4.9-1.6-4.9-4.9z m19.3-14.4c0.8 0 1.5 0.3 2.2 0.9s0.9 1.4 0.9 2.2v21.3c0 0.8-0.3 1.5-0.9 2.2s-1.4 0.9-2.2 0.9h-28.8c-0.8 0-1.5-0.3-2.2-0.9s-0.9-1.4-0.9-2.2v-21.3c0-0.8 0.3-1.5 0.9-2.2s1.4-0.9 2.2-0.9h6.9l2.5-2.5h10l2.5 2.5h6.9z m-14.4 23.1c2.4 0 4.5-0.8 6.2-2.6s2.6-3.7 2.6-6.1-0.9-4.5-2.6-6.2-3.8-2.6-6.2-2.6-4.5 0.9-6.2 2.6-2.5 3.8-2.5 6.2 0.8 4.4 2.5 6.1 3.8 2.6 6.2 2.6z' })
        )
    );
};

exports.default = IoAndroidCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-camera.js
// module id = 2063
// module chunks = 0